// ترتيب مستويات عربية
export const LEVEL_ORDER = ["الأول","الثاني","الثالث","الرابع","الخامس","السادس","السابع","الثامن"];

export const levelRank = (name) => {
  const i = LEVEL_ORDER.indexOf(name?.trim() || "");
  return i === -1 ? 999 : i;
};

// بيانات المواد
export const COURSES_DATA = [
  // دبلوم الأمن السيبراني - المستوى الأول
  { id: "CYB101", name: "التعرف على عالم الأعمال 1", diploma: "دبلوم الأمن السيبراني", levels: ["الأول"] },
  { id: "CYB102", name: "مقدمة تطبيقات الحاسب", diploma: "دبلوم الأمن السيبراني", levels: ["الأول"] },
  { id: "CYB103", name: "لغة إنجليزية 1", diploma: "دبلوم الأمن السيبراني", levels: ["الأول"] },
  { id: "CYB104", name: "خوارزميات ومنطق", diploma: "دبلوم الأمن السيبراني", levels: ["الأول"] },
  
  // دبلوم الأمن السيبراني - المستوى الثاني
  { id: "CYB201", name: "لغة إنجليزية 2", diploma: "دبلوم الأمن السيبراني", levels: ["الثاني"] },
  { id: "CYB202", name: "تطبيقات الحاسب المتقدمة", diploma: "دبلوم الأمن السيبراني", levels: ["الثاني"] },
  { id: "CYB203", name: "الرياضيات", diploma: "دبلوم الأمن السيبراني", levels: ["الثاني"] },
  { id: "CYB204", name: "التعرف على عالم الأعمال 2", diploma: "دبلوم الأمن السيبراني", levels: ["الثاني"] },
  
  // دبلوم الأمن السيبراني - المستوى الثالث
  { id: "CYB301", name: "مبادئ شبكات الحاسب", diploma: "دبلوم الأمن السيبراني", levels: ["الثالث"] },
  { id: "CYB302", name: "أساسيات برمجة الحاسب", diploma: "دبلوم الأمن السيبراني", levels: ["الثالث"] },
  { id: "CYB303", name: "أساسيات علم التشفير", diploma: "دبلوم الأمن السيبراني", levels: ["الثالث"] },
  
  // دبلوم الأمن السيبراني - المستوى الرابع
  { id: "CYB401", name: "البرمجة بلغة بايثون", diploma: "دبلوم الأمن السيبراني", levels: ["الرابع"] },
  { id: "CYB402", name: "لغة إنجليزية 3", diploma: "دبلوم الأمن السيبراني", levels: ["الرابع"] },
  { id: "CYB403", name: "البرمجة والتحويل 1", diploma: "دبلوم الأمن السيبراني", levels: ["الرابع"] },
  
  // دبلوم الأمن السيبراني - المستوى الخامس
  { id: "CYB501", name: "أساسيات الأمن السيبراني", diploma: "دبلوم الأمن السيبراني", levels: ["الخامس"] },
  { id: "CYB502", name: "نظم التشغيل 1", diploma: "دبلوم الأمن السيبراني", levels: ["الخامس"] },
  
  // دبلوم الأمن السيبراني - المستوى السادس
  { id: "CYB601", name: "الجرائم الإلكترونية", diploma: "دبلوم الأمن السيبراني", levels: ["السادس"] },
  { id: "CYB602", name: "الحوسبة السحابية", diploma: "دبلوم الأمن السيبراني", levels: ["السادس"] },
  { id: "CYB603", name: "الذكاء الاصطناعي", diploma: "دبلوم الأمن السيبراني", levels: ["السادس"] },
  
  // دبلوم الأمن السيبراني - المستوى السابع
  { id: "CYB701", name: "نظم تشغيل 2", diploma: "دبلوم الأمن السيبراني", levels: ["السابع"] },
  { id: "CYB702", name: "إدارة أمن المعلومات", diploma: "دبلوم الأمن السيبراني", levels: ["السابع"] },
  { id: "CYB703", name: "الاختراق الأخلاقي", diploma: "دبلوم الأمن السيبراني", levels: ["السابع"] },
  
  // دبلوم القانون - المستوى الأول
  { id: "LAW101", name: "مقدمة في الإحصاء", diploma: "دبلوم القانون", levels: ["الأول"] },
  { id: "LAW102", name: "لغة إنجليزية 1", diploma: "دبلوم القانون", levels: ["الأول"] },
  { id: "LAW103", name: "مبادئ قانون", diploma: "دبلوم القانون", levels: ["الأول"] },
  { id: "LAW104", name: "كتابة فنية", diploma: "دبلوم القانون", levels: ["الأول"] },
  
  // دبلوم القانون - المستوى الثاني
  { id: "LAW201", name: "مهارات التعلم", diploma: "دبلوم القانون", levels: ["الثاني"] },
  { id: "LAW202", name: "التوجيه المهني والتميز", diploma: "دبلوم القانون", levels: ["الثاني"] },
  { id: "LAW203", name: "القانون الإداري", diploma: "دبلوم القانون", levels: ["الثاني"] },
  { id: "LAW204", name: "المدخل للفقه الإسلامي", diploma: "دبلوم القانون", levels: ["الثاني"] },
  { id: "LAW205", name: "القانون الجزائي العام", diploma: "دبلوم القانون", levels: ["الثاني"] },
  
  // دبلوم القانون - المستوى الثالث
  { id: "LAW301", name: "لغة إنجليزية 2", diploma: "دبلوم القانون", levels: ["الثالث"] },
  { id: "LAW302", name: "أحكام الأسرة", diploma: "دبلوم القانون", levels: ["الثالث"] },
  { id: "LAW303", name: "أحكام الضمان", diploma: "دبلوم القانون", levels: ["الثالث"] },
  { id: "LAW304", name: "تطبيقات الحاسب المتقدمة", diploma: "دبلوم القانون", levels: ["الثالث"] },
  
  // دبلوم القانون - المستوى الرابع
  { id: "LAW401", name: "مصادر الالتزام", diploma: "دبلوم القانون", levels: ["الرابع"] },
  { id: "LAW402", name: "القانون التجاري", diploma: "دبلوم القانون", levels: ["الرابع"] },
  { id: "LAW403", name: "نظام القضاء والثبات", diploma: "دبلوم القانون", levels: ["الرابع"] },
  
  // دبلوم المستشفيات - المستوى الأول
  { id: "HOS101", name: "الرياضيات", diploma: "دبلوم المستشفيات", levels: ["الأول"] },
  { id: "HOS102", name: "لغة إنجليزية 1", diploma: "دبلوم المستشفيات", levels: ["الأول"] },
  { id: "HOS103", name: "مبادئ إدارة الأعمال", diploma: "دبلوم المستشفيات", levels: ["الأول"] },
  
  // دبلوم المستشفيات - المستوى الثاني
  { id: "HOS201", name: "مقدمة تطبيقات الحاسب", diploma: "دبلوم المستشفيات", levels: ["الثاني"] },
  { id: "HOS202", name: "التوجيه المهني والتميز", diploma: "دبلوم المستشفيات", levels: ["الثاني"] },
  { id: "HOS203", name: "كتابة فنية", diploma: "دبلوم المستشفيات", levels: ["الثاني"] },
  { id: "HOS204", name: "إدارة المستشفيات", diploma: "دبلوم المستشفيات", levels: ["الثاني"] },
  
  // دبلوم المستشفيات - المستوى الثالث
  { id: "HOS301", name: "لغة إنجليزية 2", diploma: "دبلوم المستشفيات", levels: ["الثالث"] },
  { id: "HOS302", name: "مقدمة في الإحصاء", diploma: "دبلوم المستشفيات", levels: ["الثالث"] },
  { id: "HOS303", name: "الدراسات الإسلامية", diploma: "دبلوم المستشفيات", levels: ["الثالث"] },
  { id: "HOS304", name: "تطبيقات الحاسب المتقدمة", diploma: "دبلوم المستشفيات", levels: ["الثالث"] },
  
  // دبلوم المستشفيات - المستوى الرابع
  { id: "HOS401", name: "مبادئ محاسبة", diploma: "دبلوم المستشفيات", levels: ["الرابع"] },
  { id: "HOS402", name: "إدارة الخدمات الصحية", diploma: "دبلوم المستشفيات", levels: ["الرابع"] },
  { id: "HOS403", name: "إدارة الموارد البشرية الصحية", diploma: "دبلوم المستشفيات", levels: ["الرابع"] },

  // دبلوم الموارد البشرية - المستوى الأول
  { id: "HR101", name: "الرياضيات", diploma: "دبلوم الموارد البشرية", levels: ["الأول"] },
  { id: "HR102", name: "لغة إنجليزية 1", diploma: "دبلوم الموارد البشرية", levels: ["الأول"] },
  { id: "HR103", name: "مبادئ إدارة الأعمال", diploma: "دبلوم الموارد البشرية", levels: ["الأول"] },

  // دبلوم الموارد البشرية - المستوى الثاني
  { id: "HR201", name: "التوجيه المهني والتميز", diploma: "دبلوم الموارد البشرية", levels: ["الثاني"] },
  { id: "HR202", name: "كتابة فنية", diploma: "دبلوم الموارد البشرية", levels: ["الثاني"] },
  { id: "HR203", name: "مبادئ إدارة الموارد البشرية", diploma: "دبلوم الموارد البشرية", levels: ["الثاني"] },
  { id: "HR204", name: "مهارات التعلم", diploma: "دبلوم الموارد البشرية", levels: ["الثاني"] },
  
  // دبلوم الموارد البشرية - المستوى الثالث
  { id: "HR301", name: "تحليل وتقييم الوظائف", diploma: "دبلوم الموارد البشرية", levels: ["الثالث"] },
  { id: "HR302", name: "مقدمة في الإحصاء", diploma: "دبلوم الموارد البشرية", levels: ["الثالث"] },
  { id: "HR303", name: "الدراسات الإسلامية", diploma: "دبلوم الموارد البشرية", levels: ["الثالث"] },
  { id: "HR304", name: "لغة إنجليزية 2", diploma: "دبلوم الموارد البشرية", levels: ["الثالث"] },
  
  // دبلوم الموارد البشرية - المستوى الرابع
  { id: "HR401", name: "تخطيط الموارد البشرية", diploma: "دبلوم الموارد البشرية", levels: ["الرابع"] },
  { id: "HR402", name: "مهارات التعلم", diploma: "دبلوم الموارد البشرية", levels: ["الرابع"] },
  { id: "HR403", name: "مبادئ محاسبة", diploma: "دبلوم الموارد البشرية", levels: ["الرابع"] },

  // دبلوم الادارة المكتبية - المستوى الأول
  { id: "OFF101", name: "لغة إنجليزية 1", diploma: "دبلوم الادارة المكتبية", levels: ["الأول"] },
  { id: "OFF102", name: "الرياضيات", diploma: "دبلوم الادارة المكتبية", levels: ["الأول"] },
  { id: "OFF103", name: "مبادئ إدارة الأعمال", diploma: "دبلوم الادارة المكتبية", levels: ["الأول"] },
  
  // دبلوم الادارة المكتبية - المستوى الثاني
  { id: "OFF201", name: "لغة إنجليزية 2", diploma: "دبلوم الادارة المكتبية", levels: ["الثاني"] },
  { id: "OFF202", name: "مقدمة تطبيقات الحاسب", diploma: "دبلوم الادارة المكتبية", levels: ["الثاني"] },
  { id: "OFF203", name: "كتابة فنية", diploma: "دبلوم الادارة المكتبية", levels: ["الثاني"] },
  { id: "OFF204", name: "مهارات الطباعة العربية", diploma: "دبلوم الادارة المكتبية", levels: ["الثاني"] },
  
  // دبلوم الادارة المكتبية - المستوى الثالث
  { id: "OFF301", name: "الاتصالات الإدارية", diploma: "دبلوم الادارة المكتبية", levels: ["الثالث"] },
  { id: "OFF302", name: "مهارات الطباعة انجليزي", diploma: "دبلوم الادارة المكتبية", levels: ["الثالث"] },
  { id: "OFF303", name: "مقدمة في الإحصاء", diploma: "دبلوم الادارة المكتبية", levels: ["الثالث"] },
  
  // دبلوم الادارة المكتبية - المستوى الرابع
  { id: "OFF401", name: "كتابة فنية", diploma: "دبلوم الادارة المكتبية", levels: ["الرابع"] },
  { id: "OFF402", name: "الدراسات الإسلامية", diploma: "دبلوم الادارة المكتبية", levels: ["الرابع"] },
  { id: "OFF403", name: "تطبيقات الحاسب المتقدمة", diploma: "دبلوم الادارة المكتبية", levels: ["الرابع"] },
  { id: "OFF404", name: "إدارة وتقنيات المكاتب", diploma: "دبلوم الادارة المكتبية", levels: ["الرابع"] },

  // دبلوم إدارة التمريض - المستوى الأول
  { id: "NUR101", name: "مبادئ إدارة الأعمال", diploma: "دبلوم إدارة التمريض", levels: ["الأول"] },
  { id: "NUR102", name: "مقدمة تطبيقات الحاسب", diploma: "دبلوم إدارة التمريض", levels: ["الأول"] },
  { id: "NUR103", name: "لغة إنجليزية 1", diploma: "دبلوم إدارة التمريض", levels: ["الأول"] },

  // دبلوم إدارة السلامة - المستوى الأول
  { id: "SAF101", name: "مقدمة تطبيقات الحاسب", diploma: "دبلوم إدارة السلامة", levels: ["الأول"] },
  { id: "SAF102", name: "لغة إنجليزية 1", diploma: "دبلوم إدارة السلامة", levels: ["الأول"] },
  { id: "SAF103", name: "مقدمة في السلامة والصحة المهنية", diploma: "دبلوم إدارة السلامة", levels: ["الأول"] },
  
  // دبلوم إدارة السلامة - المستوى الثاني
  { id: "SAF201", name: "الرياضيات", diploma: "دبلوم إدارة السلامة", levels: ["الثاني"] },
  { id: "SAF202", name: "التوجيه المهني والتميز", diploma: "دبلوم إدارة السلامة", levels: ["الثاني"] },
  { id: "SAF203", name: "تشريعات السلامة والصحة المهنية", diploma: "دبلوم إدارة السلامة", levels: ["الثاني"] },
  { id: "SAF204", name: "مقدمة في أنظمة ولوائح السلامة", diploma: "دبلوم إدارة السلامة", levels: ["الثاني"] },
  
  // دبلوم إدارة السلامة - المستوى الثالث
  { id: "SAF301", name: "تطبيقات الحاسب المتقدمة", diploma: "دبلوم إدارة السلامة", levels: ["الثالث"] },
  { id: "SAF302", name: "إدارة السلامة الصناعية", diploma: "دبلوم إدارة السلامة", levels: ["الثالث"] },
  { id: "SAF303", name: "متطلبات السلامة في المنشآت", diploma: "دبلوم إدارة السلامة", levels: ["الثالث"] },
  
  // دبلوم إدارة السلامة - المستوى الرابع
  { id: "SAF401", name: "لغة إنجليزية 2", diploma: "دبلوم إدارة السلامة", levels: ["الرابع"] },
  { id: "SAF402", name: "مقدمة في الإحصاء", diploma: "دبلوم إدارة السلامة", levels: ["الرابع"] },
  { id: "SAF403", name: "كتابة تقارير السلامة", diploma: "دبلوم إدارة السلامة", levels: ["الرابع"] },
  { id: "SAF404", name: "نظام إدارة السلامة والصحة المهنية", diploma: "دبلوم إدارة السلامة", levels: ["الرابع"] },

  // دبلوم إدارة الأعمال - المستوى الأول
  { id: "BUS101", name: "مقدمة تطبيقات الحاسب", diploma: "دبلوم إدارة الأعمال", levels: ["الأول"] },
  { id: "BUS102", name: "لغة إنجليزية 1", diploma: "دبلوم إدارة الأعمال", levels: ["الأول"] },
  { id: "BUS103", name: "مبادئ إدارة الأعمال", diploma: "دبلوم إدارة الأعمال", levels: ["الأول"] },
  { id: "BUS104", name: "مهارات التعلم", diploma: "دبلوم إدارة الأعمال", levels: ["الأول"] },
  
  // دبلوم إدارة الأعمال - المستوى الثاني
  { id: "BUS201", name: "الرياضيات", diploma: "دبلوم إدارة الأعمال", levels: ["الثاني"] },
  { id: "BUS202", name: "مقدمة في الاقتصاد", diploma: "دبلوم إدارة الأعمال", levels: ["الثاني"] },
  { id: "BUS203", name: "مبادئ محاسبة", diploma: "دبلوم إدارة الأعمال", levels: ["الثاني"] },
  { id: "BUS204", name: "الدراسات الإسلامية", diploma: "دبلوم إدارة الأعمال", levels: ["الثاني"] },
  
  // دبلوم إدارة الأعمال - المستوى الثالث
  { id: "BUS301", name: "التعرف على عالم الأعمال 1", diploma: "دبلوم إدارة الأعمال", levels: ["الثالث"] },
  { id: "BUS302", name: "لغة إنجليزية 2", diploma: "دبلوم إدارة الأعمال", levels: ["الثالث"] },
  { id: "BUS303", name: "السلوك التنظيمي", diploma: "دبلوم إدارة الأعمال", levels: ["الثالث"] },
  { id: "BUS304", name: "مقدمة في الإحصاء", diploma: "دبلوم إدارة الأعمال", levels: ["الثالث"] },
  
  // دبلوم إدارة الأعمال - المستوى الرابع
  { id: "BUS401", name: "مبادئ تسويق", diploma: "دبلوم إدارة الأعمال", levels: ["الرابع"] },
  { id: "BUS402", name: "إدارة الموارد البشرية", diploma: "دبلوم إدارة الأعمال", levels: ["الرابع"] },
  { id: "BUS403", name: "الإدارة المالية", diploma: "دبلوم إدارة الأعمال", levels: ["الرابع"] },
  
  // دبلوم إدارة الأعمال - المستوى الخامس
  { id: "BUS501", name: "لغة إنجليزية للأعمال", diploma: "دبلوم إدارة الأعمال", levels: ["الخامس"] },
  { id: "BUS502", name: "نظم المعلومات الإدارية", diploma: "دبلوم إدارة الأعمال", levels: ["الخامس"] },
  { id: "BUS503", name: "إدارة العمليات", diploma: "دبلوم إدارة الأعمال", levels: ["الخامس"] },
  { id: "BUS504", name: "الإدارة الإلكترونية", diploma: "دبلوم إدارة الأعمال", levels: ["الخامس"] },
  
  // دبلوم إدارة الأعمال - المستوى السادس
  { id: "BUS601", name: "إدارة الجودة الشاملة", diploma: "دبلوم إدارة الأعمال", levels: ["السادس"] },
  { id: "BUS602", name: "الإدارة الاستراتيجية", diploma: "دبلوم إدارة الأعمال", levels: ["السادس"] },
  { id: "BUS603", name: "التعرف على عالم الأعمال 2", diploma: "دبلوم إدارة الأعمال", levels: ["السادس"] },
  
  // دبلوم إدارة الأعمال - المستوى السابع
  { id: "BUS701", name: "إدارة الموارد", diploma: "دبلوم إدارة الأعمال", levels: ["السابع"] },
  { id: "BUS702", name: "إعداد التقارير الإدارية باللغة الإنجليزية", diploma: "دبلوم إدارة الأعمال", levels: ["السابع"] },
  { id: "BUS703", name: "إدارة العمليات", diploma: "دبلوم إدارة الأعمال", levels: ["السابع"] },
  
  // المواد المشتركة
  { id: "MATH001", name: "الرياضيات", diploma: "مشترك", levels: ["الأول", "الثاني"] },
  { id: "ENG1001", name: "لغة إنجليزية 1", diploma: "مشترك", levels: ["الأول"] },
  { id: "ENG1002", name: "لغة إنجليزية 2", diploma: "مشترك", levels: ["الثاني", "الثالث"] },
  { id: "BUS001", name: "مبادئ إدارة الأعمال", diploma: "مشترك", levels: ["الأول"] },
  { id: "COMP001", name: "مقدمة تطبيقات الحاسب", diploma: "مشترك", levels: ["الأول"] },
  { id: "COMP002", name: "تطبيقات الحاسب المتقدمة", diploma: "مشترك", levels: ["الثالث", "الرابع"] },
  { id: "STAT001", name: "مقدمة في الإحصاء", diploma: "مشترك", levels: ["الأول", "الثالث"] },
  { id: "WRIT001", name: "كتابة فنية", diploma: "مشترك", levels: ["الأول", "الثاني"] },
  { id: "ISLAM001", name: "الدراسات الإسلامية", diploma: "مشترك", levels: ["الثالث", "الرابع"] },
  { id: "CAREER001", name: "التوجيه المهني والتميز", diploma: "مشترك", levels: ["الثاني"] },
  { id: "ACCT001", name: "مبادئ محاسبة", diploma: "مشترك", levels: ["الرابع"] },
  { id: "SKILL001", name: "مهارات التعلم", diploma: "مشترك", levels: ["الأول", "الثاني", "الرابع"] },
];